import React from 'react';
import classNames from 'classnames';

const IconSizeSettings = (props) => {
  const size = props.size.value;
  const isActive = (val) => val === size;

  const handleChange = (val) => {
    const { onChange, size: { field } } = props;
    onChange(field, val);
  };

  const optionClasses = (val) => {
    return classNames(
      'btn btn-form',
      { 'active': isActive(val) }
    );
  };

  const options = ['16', '32'];
  const renderOption = (value, index) => (
    <a
      className={optionClasses(value)}
      onClick={() => handleChange(value)}
      key={`icon-size--${index}`}
    > { value }
    </a>
  );

  return (
    <div className="btn-group">
      {options.map(renderOption)}
    </div>
  );
}

export default IconSizeSettings;
